(function () {
    "use strict";

    angular
        .module("app")
        .directive("planningCategorySearchHelp", ["SearchFactory", planningCategorySearchHelp]);

    function planningCategorySearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.planningCategoryKey = "";
                        scope.planningCategoryName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.planningCategoryName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.planningCategorySearch(function (planningCategory) {
                        scope.planningCategoryKey = planningCategory ? planningCategory.CharacteristicValue : "";
                        scope.planningCategoryName = planningCategory ? planningCategory.CharacteristicDesc : "";
                        scope.displayValue = scope.planningCategoryName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.planningCategoryName;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("planningCategoryName", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { planningCategoryKey: "=", planningCategoryName: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

